<!-- eslint-disable max-len -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 80" x="0px" y="0px">
    <title>filter, filters</title>
    <g>
      <path
        d="M58.83,11.11a7.55,7.55,0,0,0-7.08-4.74H12.25a7.66,7.66,0,0,0-5.52,13L23.68,37V55.63a2,2,0,0,0,2,2,1.85,1.85,0,0,0,.7-.13l11.85-4.42a2,2,0,0,0,1.3-1.88V37L57.15,19.45A7.53,7.53,0,0,0,58.83,11.11Zm-4.5,5.51h0L36.12,34.78a2,2,0,0,0-.59,1.41V49.81l-7.85,2.94V36.16a2,2,0,0,0-.56-1.39L9.62,16.56a3.65,3.65,0,0,1,2.63-6.19h39.5a3.66,3.66,0,0,1,2.58,6.25Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "FilterSVG"
};
</script>

<style scoped></style>
